import { render, staticRenderFns } from "./AnaliseDocumentacaoMenu.vue?vue&type=template&id=a65cece8&scoped=true"
import script from "./AnaliseDocumentacaoMenu.vue?vue&type=script&lang=js"
export * from "./AnaliseDocumentacaoMenu.vue?vue&type=script&lang=js"
import style0 from "./AnaliseDocumentacaoMenu.vue?vue&type=style&index=0&id=a65cece8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65cece8",
  null
  
)

export default component.exports